<script>
import Layout from "@/router/layouts/auth";
import Languages from "@/components/widgets/languages";
import EcosystemUserMenu from "@/components/widgets/ecosystem-user-menu";
import ComingSoon from "@/components/widgets/coming-soon";

// Nateev: tela "em breve" no padrão visual do Tripteev
export default {
  locales: {
    pt: {
      'Back to ecosystem': 'Voltar ao ecossistema',
    },
    es: {
      'Back to ecosystem': 'Volver al ecosistema',
    },
  },
  components: {
    Layout,
    Languages,
    EcosystemUserMenu,
    ComingSoon,
  },
  data() {
    return {
      logo: require("@/assets/images/brands/nateev.svg"),
    };
  },
};
</script>

<template>
  <Layout>
    <div class="ecosystem">
      <header class="ecosystem-header">
        <router-link to="/ecosystem" class="ecosystem-back">
          <i class="bx bx-left-arrow-alt" aria-hidden="true"></i> {{ t('Back to ecosystem') }}
        </router-link>
        <div class="ecosystem-actions">
          <Languages type="right"></Languages>
          <EcosystemUserMenu></EcosystemUserMenu>
        </div>
      </header>

      <main class="ecosystem-main">
        <ComingSoon :logo="logo" name="Nateev" color="#C21D70"></ComingSoon>
      </main>
    </div>
  </Layout>
</template>
